<template lang="html">
  <div class="text-left pt-5">
    <div v-if="lang == 'en'">
      <div class="bg-title">1. Basic principles regarding personal information</div>
      <div class="content">
        fondi shall respect the privacy of users when using our service of “fondi” ((collectively,
        the “Service”) will strive to protect the personal information of users based on the
        following policies.
      </div>
      <div class="bg-title">2. Acquisition of personal information</div>
      <div class="content">
        When you use the Services, we collect information about which features you’ve used, how
        you’ve used them and the devices you use to access our services. See below for more details:
      </div>
      <div class="md-title">・Usage Information</div>
      <div class="content">
        We collect information about your activity on our services, for instance how you use them
        (e.g., date and time you logged in, features you’ve been using, searches, clicks and pages
        which have been shown to you, referring web page address, advertising that you click on) and
        how you interact with other users (e.g., users you connect and interact with, time and date
        of your exchanges, number of messages you send and receive).
      </div>
      <div class="md-title">・Device information</div>
      <div class="content">
        We collect information from and about the device(s) you use to access our services,
        including:<br />
        <ul>
          <li>
            hardware and software information such as IP address, device ID and type,
            device-specific and apps settings and characteristics, app crashes, advertising IDs
            (such as Google’s AAID and Apple's IDFA, both of which are randomly generated numbers
            that you can reset by going into your device’ settings), browser type, version and
            language, operating system, time zones, identifiers associated with cookies or other
            technologies that may uniquely identify your device or browser (e.g. IMEI/UDID and MAC
            address).
          </li>
          <li>
            information on your wireless and mobile network connection, like your service provider
            and signal strength.
          </li>
          <li>information on device sensors such as accelerometers, gyroscopes and compasses.</li>
        </ul>
      </div>
      <div class="md-title">・Other information with your consent</div>
      <div class="content">
        If you give us permission, we can collect your precise geolocation (latitude and longitude)
        through various means, depending on the service and device you’re using, including GPS,
        Bluetooth or Wi-Fi connections. The collection of your geolocation may occur in the
        background even when you aren’t using the services if the permission you gave us expressly
        permits such collection. If you decline permission for us to collect your geolocation, we
        will not collect it. Similarly, if you consent, we may collect your photos and videos (for
        instance, if you want to publish a photo, video or streaming on the services).
      </div>
      <div class="md-title">・Cookie Information</div>
      <div class="content">
        We use and may allow others to use cookies and similar technologies (e.g., web beacons,
        pixels) to recognize you and/or your device(s).
      </div>
      <div class="content">
        Some web browsers (including Safari, Internet Explorer, Firefox and Chrome) have a “Do Not
        Track” (“DNT”) feature that tells a website that a user does not want to have his or her
        online activity tracked. If a website that responds to a DNT signal receives a DNT signal,
        the browser can block that website from collecting certain information about the browser’s
        user. Not all browsers offer a DNT option and DNT signals are not yet uniform. For this
        reason, many businesses, including fondi, do not currently respond to DNT signals.
      </div>
      <div class="bg-title">3. Use of personal information</div>
      <div class="content">
        The main reason we use your information is to deliver and improve our services.
        Additionally, we use your info to help keep you safe and to provide you with advertising
        that may be of interest to you. Read on for a more detailed explanation of the various
        reasons we use your information, together with practical examples.
        <ul>
          <li>To administer your account and provide our services to you</li>
          <ul>
            <li>Create and manage your account</li>
            <li>Provide you with customer support and respond to your requests</li>
            <li>Complete your transactions</li>
            <li>Communicate with you about our services, including order management and billing</li>
          </ul>
          <li>To help you connect with other users</li>
          <ul>
            <li>
              Analyze your profile, activity on the service, and preferences to provide meaningful
              connections to you and match you with others
            </li>
            <li>Show users’ profiles to one another</li>
          </ul>
          <li>To ensure a consistent experience across your devices</li>
          <ul>
            <li>
              Link the various devices you use so that you can enjoy a consistent experience of the
              Services on all of them. We do this by linking devices and browser data, such as when
              you log into your account on different devices or by using partial or full IP address,
              browser version and similar data about your devices to help identify and link them.
            </li>
          </ul>
          <li>To provide new fondi services to you</li>
          <ul>
            <li>Register you and display your profile on new fondi features and apps</li>
            <li>Administer your account on these new features and apps</li>
          </ul>
          <li>To serve you relevant offers and ads</li>
          <ul>
            <li>Administer sweepstakes, contests, discounts or other offers</li>
            <li>
              Develop, display and track content and advertising tailored to your interests on our
              services and other sites
            </li>
            <li>
              Communicate with you by email, phone, social media or mobile device about products or
              services that we think may interest you
            </li>
          </ul>
          <li>To improve our services and develop new ones</li>
          <ul>
            <li>Administer focus groups and surveys</li>
            <li>
              Conduct research and analysis of users’ behavior to improve our services and content
              (for instance, we may decide to change the look and feel or even substantially modify
              a given feature based on users’ behavior)
            </li>
            <li>
              Develop new features and services (for example, we may decide to build a new
              interests-based feature further to requests received from users).
            </li>
          </ul>
          <li>To prevent, detect and fight fraud or other illegal or unauthorized activities</li>
          <ul>
            <li>Address ongoing or alleged misbehavior on and off-platform</li>
            <li>
              Perform data analysis to better understand and design countermeasures against these
              activities
            </li>
            <li>Retain data related to fraudulent activities to prevent against recurrences</li>
          </ul>
          <li>To ensure legal compliance</li>
          <ul>
            <li>Comply with legal requirements</li>
            <li>Assist law enforcement</li>
            <li>Enforce or exercise our rights, for example our terms and condition of use</li>
          </ul>
        </ul>
      </div>
      <div class="bg-title">4. How we share information</div>
      <div class="content">
        Since our goal is to help you make meaningful matches with other users, the main sharing of
        users’ information is with other users. We also share some users’ information with service
        providers and partners who assist us in operating the services, and in some cases, legal
        authorities. Read on for more details about how your information is shared with others.
      </div>
      <div class="content">
        <ul>
          <li>
            With other users
            <div class="mt-1">
              You share information with other users when you voluntarily disclose information on
              the service (including your public profile). Please be careful with your information
              and make sure that the content you share is stuff that you’re comfortable being
              publically viewable since neither you nor we can control what others do with your
              information once you share it.
            </div>
          </li>
          <li class="mt-3">
            With our service providers and partners
            <div class="mt-1">
              We use third parties to help us operate and improve our services. These third parties
              assist us with various tasks, including data hosting and maintenance, analytics,
              customer care, marketing, advertising, payment processing and security operations. We
              may also share information with partners who distribute and assist us in advertising
              our services. For instance, we may share limited information on you in hashed,
              non-human readable form to advertising partners.
            </div>
          </li>
          <li class="mt-3">
            For corporate transactions
            <div class="mt-1">
              We may transfer your information if we are involved, whether in whole or in part, in a
              merger, sale, acquisition, divestiture, restructuring, reorganization, dissolution,
              bankruptcy or other change of ownership or control.
            </div>
          </li>
          <li class="mt-3">
            When required by law
            <div class="mt-1">
              We may disclose your information if reasonably necessary: (i) to comply with a legal
              process, such as a court order, subpoena or search warrant, government / law
              enforcement investigation or other legal requirements; (ii) to assist in the
              prevention or detection of crime (subject in each case to applicable law); or (iii) to
              protect the safety of any person.
            </div>
          </li>
          <li class="mt-3">
            To enforce legal rights
            <div class="mt-1">
              We may also share information: (i) if disclosure would mitigate our liability in an
              actual or threatened lawsuit; (ii) as necessary to protect our legal rights and legal
              rights of our users, business partners or other interested parties; (iii) to enforce
              our agreements with you; and (iv) to investigate, prevent, or take other action
              regarding illegal activity, suspected fraud or other wrongdoing.
            </div>
          </li>
          <li class="mt-3">
            With your consent or at your request
            <div class="mt-1">
              We may ask for your consent to share your information with third parties. In any such
              case, we will make it clear why we want to share the information. We may use and share
              non-personal information (meaning information that, by itself, does not identify who
              you are such as device information, general demographics, general behavioral data,
              geolocation in de-identified form), as well as personal information in hashed,
              non-human readable form, under any of the above circumstances. We may combine personal
              information with additional non-personal information or personal information in
              hashed, non-human readable form collected from other sources.
            </div>
          </li>
        </ul>
      </div>
      <div class="bg-title">5. Disclaimer</div>
      <div class="content">
        Our company bears no responsibility for the acquisition of personal information by third
        parties under the following circumstances:
        <ul>
          <li>
            When a user discloses personal information to another user via the features of this
            service or any other method
          </li>
          <li>
            When a user can be identified by chance through activity data and information entered by
            another user
          </li>
          <li>
            When a separate user acquires information that can be used to identify the user (ID,
            password, etc.)
          </li>
        </ul>
      </div>
      <div class="bg-title">6. Release to third parties</div>
      <div class="content">
        As a general principle, the personal data of users will not be released to third parties
        without the consent of the user. Personal data will only be released after specifying its
        destination and what information will be sent, and after obtaining the consent of the user.
        However, this does not apply in the following circumstances:
        <ul>
          <li>To comply with laws and regulations</li>
          <li>
            When it is required to protect a person’s life, body, or property, and it would be
            difficult to obtain the user’s consent
          </li>
          <li>
            When it is especially required to improve public health or to promote the sound growth
            of a child and it would be difficult to obtain the user’s consent
          </li>
          <li>
            When it is required for cooperation with a state organ, a local government, or an
            external party who has taken on work from either of these, so that these organizations
            may execute work prescribed by law and regulations, and obtaining the consent of users
            could potentially impede the execution of this work
          </li>
        </ul>
      </div>
      <div class="bg-title">7. Cross - border data transfers</div>
      <div class="content">
        Sharing of information we get from users involves cross-border data transfers, for instance
        to the United States of America and other jurisdictions. As an example, where the service
        allows for users to be located in the European Economic Area (“EEA”), their personal
        information is transferred to countries outside of the EEA. Standard contractual clauses are
        commitments between companies transferring personal data, binding them to protect the
        privacy and security of your data.
      </div>
      <div class="bg-title">8. How we protect your information</div>
      <div class="content">
        We work hard to protect you from unauthorized access to or alteration, disclosure or
        destruction of your personal information. As with all technology companies, although we take
        steps to secure your information, we do not promise, and you should not expect, that your
        personal information will always remain secure. We regularly monitor our systems for
        possible vulnerabilities and attacks and regularly review our information collection,
        storage and processing practices to update our physical, technical and organizational
        security measures. We may suspend your use of all or part of the services without notice if
        we suspect or detect any breach of security. If you believe that your account or information
        is no longer secure, please notify us immediately through email to info@fondi.fun. In order
        to ensure that our systems and your information are protected against unauthorized access,
        theft and loss, we implemented a bug bounty program. For more information about our bug
        bounty program, please notify us immediately through email to
        <a href="mailto:info@fondi.fun">info@fondi.fun.</a>
      </div>
      <div class="bg-title">9. Data deletion</div>
      <div class="content">
        You may request that we delete your fondi account. On account deletion, we’ll also delete
        personal information that we hold about you. <br />
        To request deletion of your fondi account, please either do:
        <ul>
          <li>
            contact
            <a href="mailto:customer-support@fondi.fun">customer-support@fondi.fun</a> from the
            email address associated with the account to request deletion of your fondi account.
          </li>
          <li>or, request from Menu > Inquiry in the fondi application</li>
        </ul>
      </div>
      <div class="bg-title">10. Privacy Policy changes</div>
      <div class="content">
        Because we’re always looking for new and innovative ways to help you build meaningful
        connections, this policy may change over time. We will notify you before any material
        changes take effect so that you have time to review the changes.
      </div>
      <div class="bg-title">11. Other</div>
      <div class="content">
        For the use of Youtube API, please refer to
        <a href="https://policies.google.com/privacy" target="_blank">Google Privacy Policy</a>.
      </div>
      <div class="bg-title">12. How to contact us</div>
      <div class="content">
        If you have questions about this Privacy Policy, here’s how you can reach us:<br />
        <a href="mailto:info@fondi.fun">info@fondi.fun</a>
      </div>
    </div>
    <div v-else-if="lang == 'ja'">
      <div class="content">
        株式会社Compass
        Pioneering（以下，「運営」といいます。）は，運営が提供するfondiに関する全てのサービス（以下,「本サービス」といいます。）におけるプライバシー情報の取扱いについて，以下のとおりプライバシーポリシー（以下，「本ポリシー」といいます。）を定めます。
      </div>
      <div class="bg-title">第1条（プライバシー情報）</div>
      <div class="content">
        <ul>
          <li>
            プライバシー情報のうち「個人情報」とは，個人情報保護法にいう「個人情報」を指すものとし，生存する個人に関する情報であって，当該情報に含まれる氏名，生年月日，住所，電話番号，連絡先その他の記述等により特定の個人を識別できる情報を指します。
          </li>
          <li>
            プライバシー情報のうち「履歴情報および特性情報」とは，上記に定める「個人情報」以外のものをいい，ご利用いただいたサービスやご購入いただいた商品，ご覧になったページや広告の履歴，ユーザーが検索された検索キーワード，ご利用日時，ご利用の方法，ご利用環境，郵便番号や性別，職業，年齢，ユーザーのIPアドレス，クッキー情報，位置情報，端末の個体識別情報などを指します。
          </li>
        </ul>
      </div>
      <div class="bg-title">第2条（プライバシー情報の収集方法）</div>
      <div class="content">
        <ul>
          <li>
            運営は，ユーザーが利用登録をする際に氏名，生年月日，住所，電話番号，メールアドレス，銀行口座番号，クレジットカード番号，運転免許証番号などの個人情報をお尋ねすることがあります。また，ユーザーと提携先などとの間でなされたユーザーの個人情報を含む取引記録や，決済に関する情報を運営の提携先（情報提供元，広告主，広告配信先などを含みます。以下，｢提携先｣といいます。）などから収集することがあります。
          </li>
          <li>
            運営は，ユーザーについて，利用したサービスやソフトウエア，購入した商品，閲覧したページや広告の履歴，検索した検索キーワード，利用日時，利用方法，利用環境（携帯端末を通じてご利用の場合の当該端末の通信状態，利用に際しての各種設定情報なども含みます），IPアドレス，クッキー情報，位置情報，端末の個体識別情報などの履歴情報および特性情報を，ユーザーが運営や提携先のサービスを利用しまたはページを閲覧する際に収集します。
          </li>
        </ul>
      </div>
      <div class="bg-title">第3条（個人情報を収集・利用する目的）</div>
      <div class="content">
        運営は皆様の個人情報を下記の目的で取得・利用させていただきます。ご提供いただいた個人情報を目的の範囲をこえて利用することはありません。<br />
        （1）ユーザーに自分の登録情報の閲覧や修正，利用状況の閲覧を行っていただくために，氏名，住所，連絡先，支払方法などの登録情報，本サービスにおいて特定のサービスを利用する上で生じる代金などに関する情報を表示する目的<br />
        （2）ユーザーに本サービスのお知らせや連絡をするためにメールアドレスを利用する場合や必要に応じて連絡したりするため，連絡先情報を利用する目的<br />
        （3）本サービスの規約に違反する行為や、不正・不当な目的での本サービスの利用を防止する目的<br />
        （4）ユーザーに代金を請求するために，購入されたサービスの種類や期間，回数，請求金額，氏名，住所，銀行口座番号やクレジットカード番号などの支払に関する情報などを利用する目的<br />
        （5）ユーザーが簡便にデータを入力できるようにするために，運営に登録されている情報を入力画面に表示させたり，ユーザーのご指示に基づいて他のサービスなど（提携先が提供するものも含みます）に転送したりする目的<br />
        （6）本サービスを提供する上で、ユーザーが登録した顔写真とプロフィール情報を、同意を得たユーザーのみサイト上で表示し、本サービスのコミュニティ機能の提供、維持および改善のため、ユーザーの登録情報を利用する目的<br />
        ＊当項目における顔写真とプロフィール情報の表示は、ユーザー登録をした会員に対してには限らず、サイトにアクセスする全ての人に対して表示されうるものとします。<br />
        （7）ユーザーからのお問い合わせに対応するために，お問い合わせ内容や代金の請求に関する情報など運営がユーザーに対してサービスを提供するにあたって必要となる情報や，ユーザーのサービス利用状況，連絡先情報などを利用する目的<br />
        （8）その他、本サービスの適切な運営に必要なため、情報を利用する目的
      </div>
      <div class="bg-title">第4条（個人情報の第三者提供)</div>
      <div class="content">
        運営は，次に掲げる場合を除いて，あらかじめユーザーの同意を得ることなく，第三者に個人情報を提供することはありません。ただし，個人情報保護法その他の法令で認められる場合を除きます。<br />
        （1）法令に基づく場合<br />
        （2）人の生命，身体または財産の保護のために必要がある場合であって，本人の同意を得ることが困難であるとき<br />
        （3）公衆衛生の向上または児童の健全な育成の推進のために特に必要がある場合であって，本人の同意を得ることが困難であるとき<br />
        （4）国の機関もしくは地方公共団体またはその委託を受けた者が法令の定める事務を遂行することに対して協力する必要がある場合であって，本人の同意を得ることにより当該事務の遂行に支障を及ぼすおそれがあるとき<br />
        （5）予め次の事項を告知あるいは公表をしている場合<br />
        <ol>
          <li>利用目的に第三者への提供を含むこと</li>
          <li>第三者に提供されるデータの項目</li>
          <li>第三者への提供の手段または方法</li>
          <li>本人の求めに応じて個人情報の第三者への提供を停止すること</li>
        </ol>
      </div>
      <div class="content">
        前項の定めにかかわらず，次に掲げる場合は第三者には該当しないものとします。<br />
        （1）運営が利用目的の達成に必要な範囲内において個人情報の取扱いの全部または一部を委託する場合<br />
        （2）合併その他の事由による事業の承継に伴って個人情報が提供される場合<br />
        （3）個人情報を特定の者との間で共同して利用する場合であって，その旨並びに共同して利用される個人情報の項目，共同して利用する者の範囲，利用する者の利用目的および当該個人情報の管理について責任を有する者の氏名または名称について，あらかじめ本人に通知し，または本人が容易に知り得る状態に置いているとき<br />
      </div>
      <div class="bg-title">第5条（個人情報の開示）</div>
      <div class="content">
        運営は，本人から個人情報の開示を求められたときは，本人に対し，遅滞なくこれを開示します。ただし，開示することにより次のいずれかに該当する場合は，その全部または一部を開示しないこともあり，開示しない決定をした場合には，その旨を遅滞なく通知します。なお，個人情報の開示に際しては，１件あたり１，０００円の手数料を申し受けます。<br />
        （1）本人または第三者の生命，身体，財産その他の権利利益を害するおそれがある場合<br />
        （2）運営の業務の適正な実施に著しい支障を及ぼすおそれがある場合<br />
        （3）その他法令に違反することとなる場合<br />
      </div>
      <div class="content">
        前項の定めにかかわらず，履歴情報および特性情報などの個人情報以外の情報については，原則として開示いたしません。
      </div>
      <div class="bg-title">第6条（個人情報の訂正および削除）</div>
      <div class="content">
        ユーザーは，運営の保有する自己の個人情報が誤った情報である場合には，運営が定める手続きにより，運営に対して個人情報の訂正または削除を請求することができます。
      </div>
      <div class="content">
        運営は，ユーザーから前項の請求を受けてその請求に応じる必要があると判断した場合には，遅滞なく，当該個人情報の訂正または削除を行い，これをユーザーに通知します。
      </div>
      <div class="bg-title">第7条（個人情報の利用停止等）</div>
      <div class="content">
        運営は，本人から，個人情報が，利用目的の範囲を超えて取り扱われているという理由，または不正の手段により取得されたものであるという理由により，その利用の停止または消去（以下，「利用停止等」といいます。）を求められた場合には，遅滞なく必要な調査を行い，その結果に基づき，個人情報の利用停止等を行い，その旨本人に通知します。ただし，個人情報の利用停止等に多額の費用を有する場合その他利用停止等を行うことが困難な場合であって，本人の権利利益を保護するために必要なこれに代わるべき措置をとれる場合は，この代替策を講じます。
      </div>
      <div class="bg-title">第8条（データの削除）</div>
      <div class="content">
        <div>
          ユーザーは、fondiアカウントの削除を請求することができます。運営は、本人からアカウントの削除の請求があった場合、法令に基づき、アカウント及び個人情報の削除を、可能な範囲で遅滞なく行います。
          <br />fondiアカウントの削除を希望される場合は、以下の手順のいずれかに従ってください。
        </div>
        <ul>
          <li>
            アカウントで使用しているメールアドレスから<a href="mailto:customer-support@fondi.fun"
              >customer-support@fondi.fun</a
            >に連絡して、fondiアカウントの削除をリクエストしてください。
          </li>
          <li>
            もしくは、fondiアプリ内の Menu > Inquiry からお問い合わせによりリクエストしてください。
          </li>
        </ul>
      </div>
      <div class="bg-title">第9条（プライバシーポリシーの変更）</div>
      <div class="content">
        本ポリシーの内容は，ユーザーに通知することなく，変更することができるものとします。
      </div>
      <div class="content">
        運営が別途定める場合を除いて，変更後のプライバシーポリシーは，本サービスに掲載したときから効力を生じるものとします。
      </div>
      <div class="bg-title">第10条（その他）</div>
      <div class="content">
        本サービスではYoutube APIを利用しております。Googleのプライバシーポリシーは<a
          href="https://policies.google.com/privacy"
          target="_blank"
          >こちら</a
        >。
      </div>
      <div class="bg-title">第11条（お問い合わせ窓口）</div>
      <div class="content">
        本ポリシーに関するお問い合わせは、運営までEmailにてお問い合わせください。<br />
        お問い合わせ先Email : <a href="mailto:info@fondi.fun">info@fondi.fun</a>
      </div>
      <div class="content text-right mt-3">最終更新 2022年4月12日</div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['lang'],
};
</script>

<style lang="css" scoped>
.bg-title {
  font-size: 16px;
  font-weight: bold;
  letter-spacing: 0.17px;
  color: #b21977;
  padding: 16px 0 8px;
}
.md-title {
  font-size: 12px;
  font-weight: bold;
  letter-spacing: 0.13px;
  color: #2f0338;
  padding: 4px 0;
}
.content {
  font-size: 12px;
  letter-spacing: 0.13px;
  color: #2f0338;
  padding: 5px 0;
}
</style>
